import { jsx } from 'react/jsx-runtime';
import StepList from '../StepList/StepList.js';

const steps = [
    { key: "1", translation: "createAccount" },
    { key: "2", translation: "verifyAccount" },
    { key: "3", translation: "createYourWallet" },
    { key: "4", translation: "walletFile" },
    { key: "5", translation: "congratulations" },
    { key: "6", translation: "unlockWalletFile" },
];
const OnboardingStepList = ({ activeStep = 1, className = "", }) => (jsx(StepList, { active: activeStep, className: className, steps: steps }));

export { OnboardingStepList as default };
